// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchSnippet[data-v-5c3dd6da] {\n  margin: 5px 20px;\n}\n.capitalize[data-v-5c3dd6da] {\n  text-transform: capitalize;\n}\n[data-v-5c3dd6da] tbody tr.v-data-table__expanded__content {\n  background: #efefef;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}", ""]);
// Exports
module.exports = exports;
